import { proxy } from 'valtio';

const scrollState = proxy({
    top: 0,
});

export { scrollState };
